/* import __COLOCATED_TEMPLATE__ from './disabled-price-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();